module.exports = __webpack_public_path__ + "images/dingtalk/employee-b277047833dcec3384620546763ebca6.png";